import { DisruptionAlert } from "@/pages/rollshop/models/RollshopNotification";
import { CheckCircleOutline as CheckIcon } from "@mui/icons-material";
import {
	Box,
	Card,
	CardContent,
	Collapse,
	Stack,
	Typography,
	alpha,
	useTheme,
} from "@mui/material";
import { useState } from "react";
import { CardHeader } from "../NotificationDetails";
import { AlertItem } from "./AlertItem";

type Props = {
	alerts: DisruptionAlert[];
};

export const AlertsList = ({ alerts }: Props) => {
	const theme = useTheme();
	const [expanded, setExpanded] = useState(true);

	if (alerts.length === 0) {
		return (
			<Card
				elevation={0}
				sx={{
					backgroundColor: (theme) => alpha(theme.palette.success.main, 0.03),
					borderRadius: 2,
					border: (theme) =>
						`1px solid ${alpha(theme.palette.success.main, 0.15)}`,
				}}
			>
				<CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
					<Box
						sx={{
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							gap: 1,
						}}
					>
						<CheckIcon sx={{ fontSize: 18, color: "success.main" }} />
						<Typography
							variant="body2"
							fontWeight={500}
							sx={{ color: "success.main" }}
						>
							No disruptions detected
						</Typography>
					</Box>
				</CardContent>
			</Card>
		);
	}

	return (
		<Card
			elevation={0}
			sx={{
				backgroundColor: "background.paper",
				borderRadius: 2,
				border: (theme) =>
					`1px solid ${alpha(theme.palette.warning.main, 0.25)}`,
			}}
		>
			<CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
				<CardHeader
					label={`Alerts (${alerts.length})`}
					backgroundColor={theme.palette.warning.main}
					expanded={expanded}
					setExpanded={setExpanded}
				/>

				<Collapse in={expanded} timeout="auto">
					<Stack spacing={1} sx={{ mt: 2 }}>
						{alerts.map((alert) => (
							<AlertItem key={alert.DisruptionAlertId} alert={alert} />
						))}
					</Stack>
				</Collapse>
			</CardContent>
		</Card>
	);
};
